import { render, staticRenderFns } from "./AddContrastModal.vue?vue&type=template&id=564e727e&scoped=true"
import script from "./AddContrastModal.vue?vue&type=script&lang=js"
export * from "./AddContrastModal.vue?vue&type=script&lang=js"
import style0 from "./AddContrastModal.vue?vue&type=style&index=0&id=564e727e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e727e",
  null
  
)

export default component.exports